import { PASSWORD } from "../SchemaTypes";
import { useParsedFieldProps } from "./useParsedFieldProps";
import Field from "../Field";
import PasswordInput from "../../Input/PasswordInput";
import {
  MAXIMUM_STRING_LENGTH,
  MINIMUM_PASSWORD_LENGTH
} from "../../../helpers/FormValidator";

const PasswordField = ({ validatesInputLength = true, ...props }) => {
  const { fieldProps, inputProps } = useParsedFieldProps(props, {
    omit: ["confirmationOf", "validatesInputLength"]
  });
  const { required, parent, confirmationOf } = props;

  const schema = {
    type: PASSWORD,
    parent,
    validations: {
      required,
      // Only validate the length of the password if the `validatesInputLength` prop is
      // true, avoiding to validate third-party password fields that may have different
      // requirements.
      length: validatesInputLength && {
        minimum: MINIMUM_PASSWORD_LENGTH,
        maximum: MAXIMUM_STRING_LENGTH
      },
      confirmationOf
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <PasswordInput {...inputProps} />
    </Field>
  );
};

export default PasswordField;
